import { useLayoutEffect, useRef } from 'react';
import {
  NavigationType,
  useLocation,
  useNavigationType
} from 'react-router-dom';

/**
 * Starts a page opened from another at its top. The router keeps the window's scroll offset
 * across a link, so without this a page opened from far down a list (a row in Recent activity,
 * "View all" in My Donations) arrives scrolled past its own header and summary. Back and
 * forward (POP) are left alone, so the browser returns the list to where the customer was, and
 * a change of query alone (a filter on the same page) does not move the page.
 */
export const useScrollToTopOnOpen = (): void => {
  const navigationType = useNavigationType();
  const { pathname } = useLocation();
  const shownPath = useRef<string | null>(null);

  useLayoutEffect(() => {
    const opened = shownPath.current !== pathname;
    shownPath.current = pathname;
    if (opened && navigationType !== NavigationType.Pop) window.scrollTo(0, 0);
  }, [navigationType, pathname]);
};
